/*!
 * Copyright (c) 2021-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { proceed } from './proceed';
import { getSavedTransactionMeta } from './transactionMeta';
import { warn } from '../util';
export function poll(authClient, options = {}) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        let transaction = yield proceed(authClient, {
            startPolling: true
        });
        const meta = getSavedTransactionMeta(authClient);
        let availablePollingRemeditaions = (_a = meta === null || meta === void 0 ? void 0 : meta.remediations) === null || _a === void 0 ? void 0 : _a.find(remediation => remediation.includes('poll'));
        if (!(availablePollingRemeditaions === null || availablePollingRemeditaions === void 0 ? void 0 : availablePollingRemeditaions.length)) {
            warn('No polling remediations available at the current IDX flow stage');
        }
        if (Number.isInteger(options.refresh)) {
            return new Promise(function (resolve, reject) {
                setTimeout(function () {
                    var _a, _b;
                    return __awaiter(this, void 0, void 0, function* () {
                        try {
                            const refresh = (_b = (_a = transaction.nextStep) === null || _a === void 0 ? void 0 : _a.poll) === null || _b === void 0 ? void 0 : _b.refresh;
                            if (refresh) {
                                resolve(poll(authClient, {
                                    refresh
                                }));
                            }
                            else {
                                resolve(transaction);
                            }
                        }
                        catch (err) {
                            reject(err);
                        }
                    });
                }, options.refresh);
            });
        }
        return transaction;
    });
}
